import { http } from '../request'
import { expectArrayData } from './shared'

export interface AcademicYearDto {
  id: number
  name: string
  startDate: string
  endDate: string
  isCurrent?: boolean | null
  sort?: number
}

interface CreateAcademicYearRequest {
  name: string
  startDate: string
  endDate: string
  isCurrent?: boolean
  sort?: number
}

interface UpdateAcademicYearRequest {
  name?: string
  startDate?: string
  endDate?: string
  isCurrent?: boolean
  sort?: number
}

export const academicYearApi = {
  async list(): Promise<AcademicYearDto[]> {
    const response = await http.get<AcademicYearDto[]>('/academic/academic-years')
    return expectArrayData<AcademicYearDto>(response.data, '/academic/academic-years')
  },

  async create(payload: CreateAcademicYearRequest): Promise<AcademicYearDto> {
    const response = await http.post<AcademicYearDto>('/academic/academic-years', payload)
    return response.data
  },

  async update(id: number, payload: UpdateAcademicYearRequest): Promise<AcademicYearDto> {
    const response = await http.put<AcademicYearDto>(`/academic/academic-years/${id}`, payload)
    return response.data
  },

  async remove(id: number): Promise<void> {
    await http.delete(`/academic/academic-years/${id}`)
  }
}
